import { render, staticRenderFns } from "./serviceProductNew.vue?vue&type=template&id=3e180315&scoped=true"
import script from "./serviceProductNew.vue?vue&type=script&lang=js"
export * from "./serviceProductNew.vue?vue&type=script&lang=js"
import style0 from "./serviceProductNew.vue?vue&type=style&index=0&id=3e180315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e180315",
  null
  
)

export default component.exports